import React, {PropTypes} from 'react';
import {Modal} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

const ChangePasswordModal = ({
  isOpen,
  onAccept,
  onClose,
  newPassword,
  confirmPassword,
  passwordError,
  onPasswordChange,
  onConfirmPasswordChange
}) => {
  let confirmRowStyle = 'row';
  let confirmInputStyle = 'form-control';
  if(passwordError !== '')
  {
    confirmRowStyle += ' has-danger';
    confirmInputStyle += ' form-control-danger'; 
  }

  return (
    <Modal isOpen={isOpen} toggle={onClose} id="modalSelectStore">
      <div className="modal-header">
        <h4 className="modal-title" id="exampleModalLabel">{I18n.t('CHANGE_PASSWORD')}</h4>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
          <span className="lnr lnr-cross" aria-hidden="true"/>
        </button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-sm-12">
            <input className="form-control" 
                    type="password" 
                    value={newPassword} 
                    placeholder={I18n.t('NEW_PASSWORD')}
                    onChange={(e) => {onPasswordChange(e.target.value);}}
                    autoComplete="off" />
          </div>
        </div>
        <div className={confirmRowStyle}>
          <div className="col-sm-12">
            <input className={confirmInputStyle} 
                    type="password" 
                    value={confirmPassword} 
                    placeholder={I18n.t('CONFIRM_PASSWORD')}
                    onChange={(e) => {onConfirmPasswordChange(e.target.value);}}
                    autoComplete="off" />
            {passwordError !== '' && <div className="form-control-feedback">{passwordError}</div>}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={onClose}>{I18n.t('CANCEL')}</button>
        <button type="button" className="btn btn-primary" onClick={onAccept}>{I18n.t('CHANGE_PASSWORD')}</button>
      </div>
    </Modal>
  );
};

ChangePasswordModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  newPassword: PropTypes.string.isRequired,
  confirmPassword: PropTypes.string.isRequired,
  passwordError: PropTypes.string.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onConfirmPasswordChange: PropTypes.func.isRequired
};

export default ChangePasswordModal;


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/ChangePasswordModal.js
 **/